/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */
export abstract class ConnectedMessageService {
   public onMessage(id: string, type: string, callback: Function) {}
   public onPeerOpen(id: string, type: string, callback: Function) {}
   public addAcceptedId(id: string) {}
   public initConnection(id: string, type: string, description?: string) {}
   public resetConnection(id: string, type: string) {}
   public releaseConnection(id: string, type?: string) {}
   public sendMessage(id: string, type: string, content: any) {}
   public sendMessageByType(type: string, content: any) {}
}
